export const NavHomeIcon = () => {
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8916 1.31055C14.198 0.564154 15.802 0.564154 17.1084 1.31055L27.1084 7.02539C28.4325 7.78201 29.2499 9.18985 29.25 10.7148V24.2422C29.25 26.5894 27.3472 28.4922 25 28.4922H5C2.65279 28.4922 0.75 26.5894 0.75 24.2422V10.7148C0.750137 9.18985 1.56752 7.78201 2.8916 7.02539L12.8916 1.31055Z"
        fill="white"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  );
};
